<div class="schedule-summary-main">
  <div class="schedule-summary-header">
    <h1 class="schedule-summary__heading">{{'ActivitySchedules' | translate}}</h1>
  </div>
  <div class="schedule-summary-content">
    <div *ngIf="isSessionClass && !isOpenBooking">
      <div class="schedule-summary__day" *ngFor="let dateSchedule of allAvailableDates; let index = index">
        <div class="schedule-summary__day-date" *ngIf="isSessionClass">
          <mat-checkbox class="schedule-summary__checkbox" [checked]="dateSchedule.checked"
            (change)="dateClicked($event.checked, index)">
          </mat-checkbox>
          {{dateSchedule.StartDate | localizeDate: 'dddd, MMMM DD YYYY'}}
        </div>
        <div class="schedule-summary__sessions" *ngIf="isSessionClass">
          <ng-container *ngFor="let session of dateSchedule.sessions; let sessionIndex = index">
            <mat-accordion>
              <mat-expansion-panel class="panel">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="schedule-summary__session">
                      <div class="schedule-summary__session-left">
                        <mat-checkbox class="schedule-summary__checkbox" [checked]="session.checked"
                          (change)="sessionClicked(index)" (click)="$event.stopPropagation()"
                          [(ngModel)]="session.checked">
                        </mat-checkbox>
                        {{'session' | translate}} {{sessionIndex + 1}}
                      </div>
                      <div class="schedule-summary__session-right">
                        {{session.Start | localizeDate: 'LT'}} - {{session.End | localizeDate: 'LT'}}
                      </div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="schedule-summary__rate-row" *ngIf="session.RatePlanVariants.TotalBaseRate">
                  <div class="schedule-summary__rate-label">
                    <span class="schedule-summary__rate-label--main">{{'TotalBaseRate' | translate}}</span>
                  </div>
                  <div class="schedule-summary__rate">{{OperationCurrency}}
                    {{session.RatePlanVariants.TotalBaseRate | currencyDecimalFormatter}}</div>
                </div>
                <div class="schedule-summary__rate-row" *ngIf="session.RatePlanVariants.LocationVariant">
                  <div class="schedule-summary__rate-label">
                    <span class="schedule-summary__rate-label">{{'LocationVariant' | translate}} <span
                        class="sub-text">({{'forTotalOf' | translate}} {{BookingSize}}
                        )</span>
                    </span>
                  </div>
                  <div class="schedule-summary__rate">{{OperationCurrency}}
                    {{session.RatePlanVariants.LocationVariant | currencyDecimalFormatter}}</div>
                </div>
                <div class="schedule-summary__rate-row" *ngIf="session.RatePlanVariants.InstructorVariant">
                  <div class="schedule-summary__rate-label">
                    <span class="schedule-summary__rate-label">{{'InstructorVariant' | translate}} <span
                        class="sub-text">({{'forTotalOf' | translate}} {{BookingSize}}
                        )</span>
                    </span>
                  </div>
                  <div class="schedule-summary__rate">{{OperationCurrency}}
                    {{session.RatePlanVariants.InstructorVariant | currencyDecimalFormatter}}</div>
                </div>
                <div class="schedule-summary__rate-row"
                  *ngIf="session.bookingTypeVariants && session.bookingTypeVariants.length">
                  <div class="schedule-summary__rate-label">
                    <span class="schedule-summary__rate-label sub-label">{{'bookingType' | translate}} </span>
                  </div>
                </div>
                <div class="schedule-summary__rate-row" *ngFor="let variant of session.bookingTypeVariants">
                  <div class="schedule-summary__rate-label">
                    <span class="schedule-summary__rate-label--main">{{variant.BookingTypeName}}</span>
                    <span class="schedule-summary__rate-label--sub">{{variant.bookingTypes}}</span>
                  </div>
                  <div class="schedule-summary__rate">{{OperationCurrency}} {{variant.Variant |
                    currencyDecimalFormatter}}
                  </div>
                </div>
                <div class="schedule-summary__rate-row"
                  *ngIf="session.coverTypeVariants && session.coverTypeVariants.length">
                  <div class="schedule-summary__rate-label">
                    <span class="schedule-summary__rate-label sub-label">{{'coverType' | translate}} </span>
                  </div>
                </div>
                <div class="schedule-summary__rate-row" *ngFor="let variant of session.coverTypeVariants">
                  <div class="schedule-summary__rate-label">
                    <span class="schedule-summary__rate-label--main">{{variant.CoverTypeName}}</span>
                    <span class="schedule-summary__rate-label--sub">{{variant.covers}}</span>
                  </div>
                  <div class="schedule-summary__rate">{{OperationCurrency}} {{variant.Variant |
                    currencyDecimalFormatter}}
                  </div>
                </div>

                <div class="schedule-summary__rate-row" *ngIf="session.MemberShipVariant">
                  <div class="schedule-summary__rate-label">
                    <span class="schedule-summary__rate-label--main">{{'MemberShipVariant' | translate}}</span>
                  </div>
                  <div class="schedule-summary__rate">{{OperationCurrency}} {{session.MemberShipVariant |
                    currencyDecimalFormatter}}</div>
                </div>
                <div class="schedule-summary__rate-row" *ngIf="session.TotalAmount">
                  <div class="schedule-summary__rate-label">
                    <span class="schedule-summary__rate-label--main">{{'TotalSessionCharge' | translate}}</span>
                  </div>
                  <div class="schedule-summary__rate">{{OperationCurrency}} {{session.TotalAmount |
                    currencyDecimalFormatter}}</div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </ng-container>
        </div>

      </div>
    </div>
    <div *ngIf="!isSessionClass && !isOpenBooking">
      <div class="schedule-summary__day" *ngFor="let dateSchedule of allAvailableDates; let index = index">
        <div class="schedule-summary__session_class" style="background: #FFFFFF;">
          <div class="schedule-summary__day-date">
            {{dateSchedule.StartDate | localizeDate: 'dddd, MMMM DD YYYY'}} - {{dateSchedule.EndDate | localizeDate: 'dddd, MMMM DD YYYY'}}
          </div>
          <div class="column">
            <div *ngFor="let selectedDay of SelectedClassSchedule; let index = index;">
              <ng-container *ngIf="selectedDay">
                <div class="schedule-summary__session_classes padding-10px" *ngFor="let slot of selectedDay;">
                  <div class="schedule-summary__session-left">
                    {{dayOfWeek[index]}}
                  </div>
                  &nbsp;
                  <div class="schedule-summary__session-right">
                    {{slot.Start | localizeDate:'LT'}} - {{slot.End | localizeDate:'LT'}}
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="column" *ngIf="!SelectedClassSchedule || !SelectedClassSchedule.length">
            <div class="schedule-summary__session_classes padding-10px" *ngFor="let slot of selectedClassList;">
              <div class="schedule-summary__session-left">
                {{dayOfWeek[slot.Dayofweek]}}
              </div>
              &nbsp;
              <div class="schedule-summary__session-right">
                {{timeConversion(slot.StartTime , SpecialMeal ,'Start') | localizeDate:'LT' }} -
                {{timeConversion(slot.EndTime, SpecialMeal ,'End') | localizeDate:'LT'}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="schedule-summary__sessions" *ngIf="isOpenBooking">
      <ng-container *ngFor="let slot of allAvailableDates;let slotIndex =index">
        <mat-accordion>
          <mat-expansion-panel class="panel">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="schedule-summary__session">
                  <div class="schedule-summary__session-left">
                    <mat-checkbox class="schedule-summary__checkbox" [checked]="slot.checked"
                      (click)="$event.stopPropagation()" [(ngModel)]="slot.checked">
                    </mat-checkbox>
                    {{slot.StartTime | localizeDate: 'dddd, MMMM DD YYYY'}} &nbsp;
                    {{slot.StartTime | localizeDate:'LT'}} - {{slot.EndTime | localizeDate:'LT'}}
                  </div>
                  <div class="schedule-summary__session-right mod-btn-color" *ngIf="showModifybtn">
                    <a (click)="modifySelected(slot)">{{'modify' | translate}}</a>
                  </div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="schedule-summary__rate-row" *ngIf="slot.RatePlanVariants?.TotalBaseRate">
              <div class="schedule-summary__rate-label">
                <span class="schedule-summary__rate-label--main">{{'TotalBaseRate' | translate}}</span>
              </div>
              <div class="schedule-summary__rate">{{OperationCurrency}}
                {{slot.RatePlanVariants.TotalBaseRate | currencyDecimalFormatter}}</div>
            </div>
            <div class="schedule-summary__rate-row" *ngIf="slot.RatePlanVariants?.LocationVariant">
              <div class="schedule-summary__rate-label">
                <span class="schedule-summary__rate-label">{{'LocationVariant' | translate}} <span
                    class="sub-text">({{'forTotalOf' | translate}} {{BookingSize}}
                    )</span>
                </span>
              </div>
              <div class="schedule-summary__rate">{{OperationCurrency}}
                {{slot.RatePlanVariants.LocationVariant | currencyDecimalFormatter}}</div>
            </div>
            <div class="schedule-summary__rate-row" *ngIf="slot.RatePlanVariants?.InstructorVariant">
              <div class="schedule-summary__rate-label">
                <span class="schedule-summary__rate-label">{{'InstructorVariant' | translate}} <span
                    class="sub-text">({{'forTotalOf' | translate}} {{BookingSize}}
                    )</span>
                </span>
              </div>
              <div class="schedule-summary__rate">{{OperationCurrency}}
                {{slot.RatePlanVariants.InstructorVariant | currencyDecimalFormatter}}</div>
            </div>
            <div class="schedule-summary__rate-row" *ngIf="slot.bookingTypeVariants && slot.bookingTypeVariants.length">
              <div class="schedule-summary__rate-label">
                <span class="schedule-summary__rate-label sub-label">{{'coverType' | translate}} </span>
              </div>
            </div>
            <div *ngIf="slot.bookingTypeVariants">
              <div class="schedule-summary__rate-row" *ngFor="let variant of slot.bookingTypeVariants">
                <div class="schedule-summary__rate-label" *ngIf="variant.Variant">
                  <span class="schedule-summary__rate-label--main">{{variant.BookingTypeName}}</span>
                  <span class="schedule-summary__rate-label--sub">{{variant.bookingTypes}}</span>
                </div>
                <div class="schedule-summary__rate">{{OperationCurrency}} {{variant.Variant |
                  currencyDecimalFormatter}}
                </div>
              </div>
            </div>
            <div class="schedule-summary__rate-row" *ngIf="slot.coverTypeVariants && slot.coverTypeVariants.length">
              <div class="schedule-summary__rate-label">
                <span class="schedule-summary__rate-label sub-label">{{'coverType' | translate}} </span>
              </div>
            </div>
            <div *ngIf="slot.coverTypeVariants">
              <div class="schedule-summary__rate-row" *ngFor="let variant of slot.coverTypeVariants">
                <div class="schedule-summary__rate-label" *ngIf="variant.Variant">
                  <span class="schedule-summary__rate-label--main">{{variant.CoverTypeName}}</span>
                  <span class="schedule-summary__rate-label--sub">{{variant.covers}}</span>
                </div>
                <div class="schedule-summary__rate">{{OperationCurrency}} {{variant.Variant |
                  currencyDecimalFormatter}}
                </div>
              </div>
            </div>
            <div class="schedule-summary__rate-row" *ngIf="slot.MemberShipVariant">
              <div class="schedule-summary__rate-label">
                <span class="schedule-summary__rate-label--main">{{'MemberShipVariant' | translate}}</span>
              </div>
              <div class="schedule-summary__rate">{{OperationCurrency}} {{slot.MemberShipVariant |
                currencyDecimalFormatter}}</div>
            </div>
            <div class="schedule-summary__rate-row" *ngIf="slot.TotalAmount">
              <div class="schedule-summary__rate-label">
                <span class="schedule-summary__rate-label--main">{{'TotalSessionCharge' | translate}}</span>
              </div>
              <div class="schedule-summary__rate">{{OperationCurrency}} {{slot.TotalAmount |
                currencyDecimalFormatter}}</div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-container>

    </div>
  </div>
  <div class="schedule-summary__footer">
    <app-button [buttontype]="cancelButton"
      *ngIf="(!isSessionClass && !isOpenBooking) ? (  PartyData ? (PartyData.State !== PartyState.Seated) :true) : allAvailableDates.length > 0 "
      (valueChange)="cancelClick()">
    </app-button>
    <ng-container *ngIf="!gs.selectedSpecialMeal?.IsForStandbyReservations">
      <app-button [buttontype]="modifyButton"
        *ngIf="!isOpenBooking && ((!isSessionClass && !isOpenBooking) ? (PartyData ? (PartyData.State !== PartyState.Seated) :true ) : (allAvailableDates.length > 0 ))"
        (valueChange)="modifyClick()">
      </app-button>
    </ng-container>
    <app-button [buttontype]="additionalGuestBtn" *ngIf="gs.additionalGuestPage && gs.additionalGuestRequired > 0"
      (valueChange)="additionalGuest()"></app-button>

    <app-button class="btn-class" [buttontype]="BookAnotherReservationBtn" *ngIf="!ratePlanfromToken"
      (valueChange)="bookAnotherReservationBtn($event)">
    </app-button>
    <app-button class="btn-class" [buttontype]="backToSummarybtn" *ngIf="gs.isSummaryFromCart"
    (valueChange)="backToCartSummary($event)">
  </app-button>
  </div>

</div>